import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import GlobalConfig from '@/model/global/GlobalSettings'

const path = 'user-analysis'

/**
 * Analyzes user consumption frequency by time period.
 * @param {Object} request - The analysis request.
 * @param {number} request.blId - Business Layer ID.
 * @param {string} request.startTime - Start time in ISO format.
 * @param {string} request.endTime - End time in ISO format.
 * @returns {Promise<Object>} - The consumption frequency analysis.
 */
export async function analyzeConsumptionFrequency (request) {
  return await hillo.jsonPost(cloudV2Url + path + '/consumption-frequency', {
    ...request,
    blId: request.blId || GlobalConfig.blId
  })
}

/**
 * Analyzes user consumption preferences.
 * @param {Object} request - The analysis request.
 * @param {number} request.blId - Business Layer ID.
 * @param {string} request.startTime - Start time in ISO format.
 * @param {string} request.endTime - End time in ISO format.
 * @returns {Promise<Object>} - The consumption preferences analysis.
 */
export async function analyzeConsumptionPreferences (request) {
  return await hillo.jsonPost(cloudV2Url + path + '/consumption-preferences', {
    ...request,
    blId: request.blId || GlobalConfig.blId
  })
}

/**
 * Generates user profile analysis.
 * @param {number} blId - Business Layer ID.
 * @returns {Promise<Object>} - The user profile analysis.
 */
export async function analyzeUserProfile (blId = GlobalConfig.blId) {
  return await hillo.get(cloudV2Url + path + '/user-profile/' + blId)
}

/**
 * Analyzes asset usage.
 * @param {Object} request - The analysis request.
 * @param {number} request.blId - Business Layer ID.
 * @param {string} request.startTime - Start time in ISO format.
 * @param {string} request.endTime - End time in ISO format.
 * @returns {Promise<Object>} - The asset usage analysis.
 */
export async function analyzeAssetUsage (request) {
  return await hillo.jsonPost(cloudV2Url + path + '/asset-usage', {
    ...request,
    blId: request.blId || GlobalConfig.blId
  })
}

/**
 * Analyzes coupon usage.
 * @param {Object} request - The analysis request.
 * @param {number} request.blId - Business Layer ID.
 * @param {string} request.startTime - Start time in ISO format.
 * @param {string} request.endTime - End time in ISO format.
 * @returns {Promise<Object>} - The coupon usage analysis.
 */
export async function analyzeCouponUsage (request) {
  return await hillo.jsonPost(cloudV2Url + path + '/coupon-usage', {
    ...request,
    blId: request.blId || GlobalConfig.blId
  })
}

/**
 * Gets a comprehensive analysis that includes all analyses.
 * @param {Object} request - The analysis request.
 * @param {number} request.blId - Business Layer ID.
 * @param {string} request.startTime - Start time in ISO format.
 * @param {string} request.endTime - End time in ISO format.
 * @returns {Promise<Object>} - The comprehensive analysis.
 */
export async function getComprehensiveAnalysis (request) {
  return await hillo.jsonPost(cloudV2Url + path + '/comprehensive', {
    ...request,
    blId: request.blId || GlobalConfig.blId
  })
}
